<template>
  <react-wrapper :component="unauthenticatedLanding" :style="{ height: '100%' }" />
</template>

<script lang="ts">
import UnauthenticatedLanding from '@/react-components/pages/unauthenticated-landing'

export default {
  computed: {
    unauthenticatedLanding() {
      return UnauthenticatedLanding
    },
  },
}
</script>
